import { render, staticRenderFns } from "./myLive.vue?vue&type=template&id=640b981c&scoped=true&"
import script from "./myLive.vue?vue&type=script&lang=js&"
export * from "./myLive.vue?vue&type=script&lang=js&"
import style0 from "./myLive.vue?vue&type=style&index=0&id=640b981c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b981c",
  null
  
)

export default component.exports